import { gql } from '@/shared/graphql/generated/lp';

export const getOpenOrdersByAccountQuery = gql(/* GraphQL */ `
  query getOpenOrdersByAccount($idSs58: String!) {
    account: accountByIdSs58(idSs58: $idSs58) {
      openOrders: poolOrdersByLiquidityProviderId(
        condition: { status: OPEN }
        orderBy: ORDER_CREATED_EVENT_ID_DESC
      ) {
        nodes {
          ...PoolOrder
        }
      }
    }
  }
`);

export const getOrdersByAccountQuery = gql(/* GraphQL */ `
  query getOrdersByAccount(
    $first: Int!
    $idSs58: String!
    $baseAsset: ChainflipAsset
    $orderBy: [PoolOrdersOrderBy!]
  ) {
    account: accountByIdSs58(idSs58: $idSs58) {
      allOrders: poolOrdersByLiquidityProviderId(
        orderBy: $orderBy
        first: $first
        filter: { baseAsset: { equalTo: $baseAsset } }
      ) {
        nodes {
          ...PoolOrder
        }
      }
    }
  }
`);

gql(/* GraphQL */ `
  fragment PoolOrder on PoolOrder {
    id
    orderId
    liquidityProviderId
    orderType
    status
    lowerTick
    upperTick
    filledQuoteAmount
    quoteAsset
    quoteAmount
    quoteCollectedFees
    baseAsset
    filledBaseAmount
    baseAmount
    baseCollectedFees
    orderCreatedEventId
    orderLastUpdatedEventId
    orderCreatedTimestamp
  }
`);
